import { createFetchTypes } from '../../utils/createFetchTypes';

export const SET_SELECTED_PATIENT = 'SET_SELECTED_PATIENT';
export const PENDING_LOAD_MORE_PATIENTS = 'PENDING_LOAD_MORE_PATIENTS';
export const DELETE_PATIENT = 'DELETE_PATIENT';
export const LIST_OF_SELECT_PATIENTS = 'LIST_OF_SELECT_PATIENTS';
export const ADD_PATIENT_TO_LIST = 'ADD_PATIENT_TO_LIST';
export const DELETE_SELECTED_PATIENT = 'DELETE_SELECTED_PATIENT';
export const DEL_ALL_SELECTED_PATIENT = 'DEL_ALL_SELECTED_PATIENT';
export const REPLACE_EDITED_PATIENT = 'REPLACE_EDITED_PATIENT';
export const SUMMON_PATIENT = 'SUMMON_PATIENT';
// ************ createFetchTypes

export const LOAD_PATIENTS = createFetchTypes('LOAD_PATIENTS');
export const GET_PATIENTS = createFetchTypes('GET_PATIENTS');
export const GET_PATIENT = createFetchTypes('GET_PATIENT');
